export default __webpack_public_path__ + "static/media/151-draws.f0dee0a2.png";